<template>
  <div v-cloak id="contract-inc-dec">
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-button
          @click="DeductAndIncrease()"
          class="vs-component vs-button bg_l_green"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />{{
            $t("CreateDeductionAndIncreaseByProduct")
          }}
        </vs-button>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-button
          @click="uploadFile()"
          class="bg_m_green float-right"
          v-if="fileUploaded"
          :disabled="disabledBtn"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("UploadFile") }}
        </vs-button>
        <label class="custom-file-upload">
          <input
            type="file"
            id="file"
            ref="file"
            v-on:change="handleFileUpload()"
          />

          <feather-icon icon="PaperclipIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("ChooseFile") }}
          <span v-if="uploadedFileName" class="file-name">{{
            uploadedFileName
          }}</span>
        </label>
      </div>
    </div>
    <deduction-increase-popup
      :show="DeductionAndIncreasePopup"
      :model="modalModel"
      @finish="onfinish"
      @close="closeDeductionAndIncreasePopup"
    ></deduction-increase-popup>
    <product-popup
      :show="showProductPopup"
      :specificProductModel="productModalModel"
      @finish="onProductModalfinish"
    ></product-popup>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('Title'), sort: 'Title' },
            { title: $t('ToleranceType'), sort: 'ToleranceType' },
            { title: $t('ID') },
            { title: $t('Amount'), sort: 'Amount' },
            { title: $t('Action') },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 30%">
              {{ row.title }}
            </td>
            <td style="width: 15%">
              <span v-if="row.toleranceType == '2'">مقداری</span>
              <span v-if="row.toleranceType == '1'">درصدی</span>
            </td>
            <td style="width: 15%">
              {{ row.id }}
            </td>
            <td style="width: 15%">
              {{ Number(row.amount).toLocaleString() }}
            </td>
            <td style="width: 20%">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-edit"
                class="bordered-btn"
                @click.prevent="productPopup(row.id)"
                >{{ $t("Products") }}</vs-button
              >
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                @click.prevent="editItem()"
                class="ml-4 d-inline"
              ></vs-button>
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="deleteItem(row.id)"
                class="d-inline"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#contract-inc-dec .bg_l_green:hover {
  color: #fff !important;
}
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}
.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import DeductionIncreasePopup from "./DeductionIncreasePopup.vue";
import ProductPopup from "./ProductPopup.vue";
export default {
  name: "saleManagement_Contract_Management_DeducationAndIncrease",
  components: {
    DataGrid,
    DeductionIncreasePopup,
    ProductPopup,
  },
  data() {
    var id = this.$route.params.id;
    return {
      DeductionAndIncreasePopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "Sales/api/SpecificProductDeductionAndIncreasesQuery/" + id,
      },
      gridSearchData: {},
      showProductPopup: false,
      productModalModel: {},
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      showLoading: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
    };
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
  },
  methods: {
    ...mapActions({
      deleteDeductionAndIncreases:
        "deductionAndIncrease/deleteDeductionAndIncreases",
      importSpecificProductDeductionAndIncreases:
        "excel/importSpecificProductDeductionAndIncreases",
    }),
    DeductAndIncrease() {
      this.modalModel = { contractId: this.$route.params.id };
      this.DeductionAndIncreasePopup = true;
    },
    editItem() {},
    deleteItem(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.deleteDeductionAndIncreases(id).then(() => {
            setTimeout(() => {
              this.$refs.grid.renderGrid();
            }, 0);
          });
        }
      });
    },
    closeDeductionAndIncreasePopup() {
      this.DeductionAndIncreasePopup = false;
    },
    onfinish() {
      this.closeDeductionAndIncreasePopup();
      this.$refs.grid.renderGrid();
    },
    productPopup(deductionAndIncreaseId) {
      this.productModalModel = {
        contractId: this.$route.params.id,
        deductionAndIncreaseId: deductionAndIncreaseId,
      };
      this.showProductPopup = true;
    },
    onProductModalfinish() {
      this.showProductPopup = false;
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.showLoading = true;
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.importSpecificProductDeductionAndIncreases(formData).then(() => {
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtn = false;
        this.showLoading = false;
      }, 1000);
    },
  },
};
</script>
